import React from 'react';
import ReactPaginate, { ReactPaginateProps } from 'react-paginate';

import { ReactComponent as ArrowLeft } from '../../assets/icons/ubr_arrow_left.svg';
import { ReactComponent as ArrowRight } from '../../assets/icons/ubr_arrow_right.svg';
import { PaginationContainer, PageSize, ReactSelectCustom } from './styles';

interface PaginationProps extends ReactPaginateProps {
  onPageSize?: (pageSize: { value: number }) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  onPageSize,
  ...props
}) => {
  const options = [
    { value: 5, label: 5 },
    { value: 10, label: 10 },
    { value: 20, label: 20 },
  ];

  return (
    <PaginationContainer>
      <PageSize>
        Dados por página
        <ReactSelectCustom
          classNamePrefix="react-select"
          onChange={onPageSize}
          options={options}
          defaultValue={{ label: 5, value: 5 }}
          placeholder={5}
          isSearchable={false}
          {...props}
        />
      </PageSize>
      <ReactPaginate
        previousLabel={<ArrowLeft />}
        nextLabel={<ArrowRight />}
        breakLabel={'...'}
        breakClassName={'break-me'}
        containerClassName={'pagination'}
        activeClassName={'active'}
        {...props}
      />
    </PaginationContainer>
  );
};
